import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { SavedRepliesPageLayout } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPage'
import { EditSaveReplyContent } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/EditSaveReplyContent/EditSaveReplyContent'
import { SavedRepliesRoutes } from './type'

export const SavedRepliesRouter = observer(() => {
  return (
    <Routes>
      <Route element={<SavedRepliesPageLayout />}>
        <Route index element={<EditSaveReplyContent />} />
        <Route path={`${SavedRepliesRoutes.create}`} element={<EditSaveReplyContent />} />
      </Route>
    </Routes>
  )
})
